<template>
  <v-container>
 <doacoes-vue @refuse="closedialog" :dialog="doacoes"></doacoes-vue>
    <div style="display: flex;">

      <v-spacer></v-spacer>

      <v-btn @click="doacoes = !doacoes" prepend-icon="mdi-hand-heart" class="pulsing-btn donate-button">
        Doar
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-card color="surface-variant" variant="outlined" title="Exames Ligeiro/ Pesados" max-width="300"
          class="mx-auto">
          <v-img :src="require('@/assets/logo.png')"></v-img>
          <template v-slot:actions>
            <v-btn :to="{ name: 'ExameList', params: { id: 1 } }" append-icon="mdi-chevron-right" color="red-lighten-2"
              text="Explorar" variant="outlined" block></v-btn>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-card color="surface-variant" title="Exames Profissional" max-width="300" class="mx-auto">
          <v-img :src="require('@/assets/logo.png')"></v-img>
          <template v-slot:actions>
            <v-btn :to="{ name: 'ExameList', params: { id: 2 } }" append-icon="mdi-chevron-right" color="red-lighten-2"
              text="Explorar" variant="outlined" block></v-btn>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-btn :to="{ name: 'Dash' }">Dash Board</v-btn> -->

  </v-container>
</template>

<script lang="ts">
import doacoesVue from '@/components/doacoes.vue';
import { defineComponent } from 'vue';
export default defineComponent({
  components:{
  doacoesVue

},
  name: 'HomeView',
  data() {

    return {doacoes:false}
  },
  mounted() {

  },
  methods: {
    closedialog(){
      this.doacoes = ! this.doacoes
    }
  },
});
</script>
